import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';
import { FilesService } from '../../services/files/files.service';
import {catchError} from 'rxjs/operators';
import {NotificationService} from '../notification/notification.service';
import * as localStorageConstants from "../../../../constants/local-storage-variables";

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  id: string = '';

  constructor(
    private http: HttpClient,
    private erService: EnvironmentResolveService,
    private fileService: FilesService,
    private notificationService: NotificationService
    ) {}

  public getReports(paging): Observable<any> {
    return this.http.post(this.erService.environmentERS.apiUrl, {
      application: 'Reporting',
      method: 'searchPortalViews',
      parameters: {
        filter: [],
        paging
      }
    });
  }

  public getReport(id: string): Observable<any> {
    const accountId = localStorage.getItem(localStorageConstants.USER_ID);
    console.log('getReport', id, accountId);
    return this.http.get(this.erService.environmentERS.apiUrl + '/../download/export/' + id + '/' + accountId,
      {responseType: 'blob', headers : new HttpHeaders({ 'Content-Type': 'application/octet-stream' })}
    ).pipe(
      catchError(error => {
        this.notificationService.showErrorNotification('An error occurred while generating export data. Please check if the export query is valid.');
        return throwError(error);
      })
    );
  }
}
